<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 222.36 39.04"
  >
    <defs>
      <linearGradient
        :id="random"
        x1="47.53"
        y1="79.1"
        x2="170.71"
        y2="-44.08"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" :stop-color="gradientStart" />
        <stop offset="1" :stop-color="gradientStop" />
      </linearGradient>
    </defs>
    <title>Unraid Logo</title>
    <path
      d="M146.7,29.47H135l-3,9h-6.49L138.93,0h8l13.41,38.49h-7.09L142.62,6.93l-5.83,16.88h8ZM29.69,0V25.4c0,8.91-5.77,13.64-14.9,13.64S0,34.31,0,25.4V0H6.54V25.4c0,5.17,3.19,7.92,8.25,7.92s8.36-2.75,8.36-7.92V0ZM50.86,12v26.5H44.31V0h6.11l17,26.5V0H74V38.49H67.9ZM171.29,0h6.54V38.49h-6.54Zm51.07,24.69c0,9-5.88,13.8-15.17,13.8H192.67V0H207.3c9.18,0,15.06,4.78,15.06,13.8ZM215.82,13.8c0-5.28-3.3-8.14-8.52-8.14h-8.08V32.77h8c5.33,0,8.63-2.8,8.63-8.08ZM108.31,23.92c4.34-1.6,6.93-5.28,6.93-11.55C115.24,3.68,110.18,0,102.48,0H88.84V38.49h6.55V5.66h6.87c3.8,0,6.21,1.82,6.21,6.71s-2.41,6.76-6.21,6.76H98.88l9.21,19.36h7.53Z"
      :fill="`url(#${random})`"
    />
  </svg>
</template>

<script>
/**
 * @name Unraid Logo
 * @prop {string} gradientStart - optional HEX color value
 * @prop {string} gradientStop - optional HEX color value
 */
export default {
  name: 'logo',
  props: {
    gradientStart: {
      type: String,
      default: '#e32929'
    },
    gradientStop: {
      type: String,
      default: '#ff8d30'
    }
  },
  data: () => ({
    // used to create a random ID for the linear gradient
    random: Math.random()
      .toString(36)
      .substring(7)
  })
};
</script>
